/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
// import Tables from "layouts/tables";
// import Billing from "layouts/billing";
// import RTL from "layouts/rtl";
// import Notifications from "layouts/notifications";
// import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Users from "layouts/dashboard/users";
import Influencers from "layouts/influencers";
import AddedCreatorsLayout from "layouts/addedcreators";
import UpdatedCreatorsLayout from "layouts/updatedcreators";
import QueriesLayout from "layouts/queries";

// @mui icons
import Icon from "@mui/material/Icon";
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import Category from "@mui/icons-material/Category";
import PostAddIcon from '@mui/icons-material/PostAdd';
import UpdateIcon from '@mui/icons-material/Update';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import UpdatedCategoriesLayout from "layouts/updatedcategories";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    key: "sign-in",
    route: "/authentication/sign-in",
    component: <SignIn />
  },
  {
    key: "sign-up",
    route: "/authentication/sign-up",
    component: <SignUp />
  },
  {
    type: "collapse",
    key: "users",
    name: "Users",
    icon: <PeopleOutlineOutlinedIcon />,
    route: "/users",
    component: <Users />
  },
  {
    type: "collapse",
    key: "search-influencer",
    name: "Search Influencers",
    icon: <ConnectWithoutContactIcon />,
    route: "/search-influencer",
    component: <Influencers />
  },
  {
    type: "collapse",
    key: "added-influencers",
    name: "Added Influencers",
    icon: <PostAddIcon />,
    route: "/added-influencers",
    component: <AddedCreatorsLayout />
  },
  {
    type: "collapse",
    key: "updated-influencers",
    name: "Updated Influencers",
    icon: <UpdateIcon />,
    route: "/updated-influencers",
    component: <UpdatedCreatorsLayout />
  },
  {
    type: "collapse",
    key: "updated-categories",
    name: "Updated Categories",
    icon: <Category />,
    route: "/updated-categories",
    component: <UpdatedCategoriesLayout />
  },
  {
    type: "collapse",
    key: "sales-queries",
    name: "Queries",
    icon: <ContactSupportIcon />,
    route: "/sales-queries",
    component: <QueriesLayout />
  }
];

export default routes;
